import { BuildMode } from "@/types";

export enum Event {
  ShareActionFallbacked = "Share action fallback",
}

export const trackEvent = async (event: Event, severity: string = "info"): Promise<void> => {
  if (!isSentryAllowed()) {
    return;
  }

  if (typeof window.Sentry === "undefined") {
    console.warn("Sentry not found.");
  } else {
    window.Sentry.captureMessage(event, severity);
  }
};

export const captureException = (error: unknown): void => {
  if (!isSentryAllowed()) {
    return;
  }

  if (typeof window.Sentry === "undefined") {
    console.warn("Sentry not found.");
    return;
  }

  window.Sentry.captureException(error);
};

const isSentryAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production, BuildMode.Beta];
  const mode = import.meta.env.MODE as BuildMode;
  return allowedModes.includes(mode);
};
